// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Jp from "blockly/msg/ja";
import En from "blockly/msg/en";
import * as Blockly from "blockly";
import Zh from "blockly/msg/zh-hant";
import ZhCn from "blockly/msg/zh-hans";

export const InitMsg = (locale: string) => {
  if (locale === "ja") {
    Blockly.setLocale(Jp);
    Blockly.Msg["COURSE_START_BLOCK"] = "         じっこう         ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_MOVE"] = "    すすむ    ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_LEFT"] = "    ひだりへ    ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_RIGHT"] = "    みぎへ    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_MOVE"] = "    まえにすすむ    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_LEFT"] = "    ひだりをむく    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_RIGHT"] = "    みぎをむく    ";
    Blockly.Msg["COURSE_TANGIBLE_REPEAT"] = "くりかえす　　　　じょうけん";
    Blockly.Msg["COURSE_TANGIBLE_IF"] = "もし　　　　じょうけん";
    Blockly.Msg["COURSE_ALGORITHM_REPEAT"] = "かい くりかえす";
    Blockly.Msg["COURSE_ALGORITHM_WHILE_UNTIL"] = "いろまで　くりかえす";

    Blockly.Msg["COURSE_PROGRAM_CLOCK_HOUR"] = "とけいのじかんを%1じ にする";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_MINUTE"] = "とけいのじかんを%1ふん にする";
    Blockly.Msg["COURSE_PROGRAM_CLOCK"] = "とけいのじかんを%1じ %2ふん にする";
    Blockly.Msg["COURSE_PROGRAM_SETTER_X_COORDINATE"] = "%1のXざひょうを%2にいどうする";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_SHOT_HAND"] = "みじかい　はり";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_LONG_HAND"] = "ながい　はり";

    Blockly.Msg["GETTER_VALUE"] = "%1のあたい";

    Blockly.Msg["UNNAMED_KEY"] = "なまえなし";
    Blockly.Msg["CUSTOM_VARIABLE_DEFAULT_NAME"] = "へんすう";
    Blockly.Msg["DUPLICATE_BLOCK"] = "コピー";
    Blockly.Msg["ADD_COMMENT"] = "コメントをついか";
    Blockly.Msg["CHANGE_VALUE_TITLE"] = "あたいをかえる：";
    Blockly.Msg["COLLAPSE_BLOCK"] = "ブロックをおりたたむ";
    Blockly.Msg["ENABLE_BLOCK"] = "ブロックをゆうこうにする";
    Blockly.Msg["DISABLE_BLOCK"] = "ブロックをむこうにする";
    Blockly.Msg["DELETE_BLOCK"] = "ブロックをさくじょする";
    Blockly.Msg["DELETE_X_BLOCKS"] = "ブロックをさくじょする";
    Blockly.Msg["EXTERNAL_INPUTS"] = "がいぶにゅうりょく";

    Blockly.Msg["CONTROLS_REPEAT_TITLE"] = "%1 かいくりかえす";
    Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"] = "じっこう";
    Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_UNTIL"] = "くりかえす：おわるじょうけん";
    Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_WHILE"] = "くりかえす：つづけるじょうけん";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK"] = "ループからぬけだす";
    Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE"] =
      "ループのつぎのくりかえすしょりをぞっこうします";

    Blockly.Msg["CONTROLS_IF_MSG_THEN"] = "じっこう";

    Blockly.Msg["MATH_ROUND_OPERATOR_ROUND"] = "ししゃごにゅう";
    Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDDOWN"] = "きりすて";
    Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDUP"] = "きりあげ";
    Blockly.Msg["MATH_ROUND_TOOLTIP"] = "すうちをきりあげるかきりすてる";
    Blockly.Msg["MATH_MODULO_TITLE"] = "%1÷%2のあまり";
    Blockly.Msg["MATH_MODULO_TOOLTIP"] = "2つのすうちのわりさんのあまりをかえす。";
    Blockly.Msg["MATH_CONSTRAIN_TITLE"] = "%1 を %2 いじょう %3 いかのはんいにせいげん";
    Blockly.Msg["MATH_CONSTRAIN_TOOLTIP"] =
      "していしたじょうげんとかげんのあいだにあたいをせいげんする（じょうげんとかげんのあたいをふくむ）。";
    Blockly.Msg["MATH_RANDOM_FLOAT_TITLE_RANDOM"] = "1みまんのせいのらんすう";
    Blockly.Msg["MATH_RANDOM_INT_TITLE"] = "%1から%2までのランダムなせいすう";

    Blockly.Msg["COLOUR_RANDOM_TITLE"] = "ランダムないろ";
    Blockly.Msg["COLOUR_RANDOM_TOOLTIP"] = "ランダムにいろをえらぶ。";
    Blockly.Msg["COLOUR_RGB_BLUE"] = "あお";
    Blockly.Msg["COLOUR_RGB_GREEN"] = "みどり";
    Blockly.Msg["COLOUR_RGB_RED"] = "あか";
    Blockly.Msg["COLOUR_RGB_TITLE"] = "いろ:";
    Blockly.Msg["COLOUR_BLEND_COLOUR1"] = "いろ 1";
    Blockly.Msg["COLOUR_BLEND_COLOUR2"] = "いろ 2";
    Blockly.Msg["COLOUR_BLEND_RATIO"] = "ひりつ";
    Blockly.Msg["COLOUR_BLEND_TITLE"] = "ブレンド";

    Blockly.Msg["VARIABLES_DEFAULT_NAME"] = "へんすう1";
    Blockly.Msg["NEW_VARIABLE"] = "へんすうをつくる";
    Blockly.Msg["NEW_VARIABLE_TITLE"] = "あたらしいへんすうのなまえ:";
    Blockly.Msg["RENAME_VARIABLE"] = "へんすうのなまえをかえる…";
    Blockly.Msg["RENAME_VARIABLE_TITLE"] = `"%1"のなまえをかえる：`;
    Blockly.Msg["DELETE_VARIABLE"] = "へんすう '%1' をさくじょ";

    Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"] = "かんすう";
    Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"] = "なにかする";
    Blockly.Msg["PROCEDURES_MUTATORARG_TITLE"] = "にゅうりょくめい:";
    Blockly.Msg["PROCEDURES_MUTATORARG_TOOLTIP"] = "かんすうへのにゅうりょくのついか。";
    Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TITLE"] = "にゅうりょく";
    Blockly.Msg["PROCEDURES_DEFNORETURN_TOOLTIP"] = "しゅつりょくなしのかんすうをさくせいします。";

    Blockly.Msg["PROCEDURES_DEFRETURN_TITLE"] = "かんすう";
    Blockly.Msg["PROCEDURES_DEFRETURN_PROCEDURE"] = "なにかする";
    Blockly.Msg["PROCEDURES_DEFRETURN_RETURN"] = "かえす";
    Blockly.Msg["PROCEDURES_DEFRETURN_TOOLTIP"] =
      "ひとつのしゅつりょくをもつかんすうをさくせいします。";

    Blockly.Msg["DEFAULT_COMPONENT"] = "パーツ";
    Blockly.Msg["EVENT_CLICK"] = "を おしたとき";
    Blockly.Msg["DISPLAY_EVENT"] = "を ひょうじする";

    Blockly.Msg["SCREEN_EVENT_LOADING"] = "がひょうじされたとき";
    Blockly.Msg["SCREEN_EVENT_NAVIGATE"] = "へいどう";
    Blockly.Msg["SCREEN_GETTER_BACKGROUND_COLOR"] = "のはいけいのいろ";
    Blockly.Msg["SCREEN_SETTER_BACKGROUND_COLOR"] = "のはいけいのいろを";

    Blockly.Msg["TOGGLE_GETTER_VALUE"] = "%1のあたい";
    Blockly.Msg["TOGGLE_SETTER_VALUE"] = "%1のあたいを%2にする";

    Blockly.Msg["CHECKBOX_EVENT_CHECK"] = "がチェックされたとき";
    Blockly.Msg["SWITCH_EVENT_VALUE_CHANGE"] = "のがかわったとき";

    Blockly.Msg["TEXTINPUT_EVENT_VALUE_CHANGE"] = "がにゅうりょくされたとき";
    Blockly.Msg["TEXTINPUT_GETTER_VALUE"] = "%1がにゅうりょくされたあたい";
    Blockly.Msg["TEXTINPUT_SETTER_VALUE"] = "%1のあたいを%2にする";

    Blockly.Msg["IMAGE_SETTER_SRC"] = "%1のがぞうを%2にする";

    Blockly.Msg["DISPLAY_ORDER"] = "のひょうじを";
    Blockly.Msg["DISPLAY_ORDER_TOP"] = "いちばんうえ";
    Blockly.Msg["DISPLAY_ORDER_BOTTOM"] = "いちばんした";

    Blockly.Msg["GETTER_OPACITY"] = "%1のとうめいど";
    Blockly.Msg["SETTER_OPACITY"] = "%1のとうめいどを%2にする";
    Blockly.Msg["SETTER_OPACITY_BY_STEP"] = "%1とうめいどを%2ずつかえる";
    Blockly.Msg["SETTER_OPACITY_BY_TIME"] = "%1びょうで%2のとうめいどを%3にする";

    Blockly.Msg["GETTER_BACKGROUND_COLOR"] = "%1のはいけいのいろ";
    Blockly.Msg["SETTER_BACKGROUND_COLOR"] = "%1のはいけいのいろを%2にする";

    Blockly.Msg["GETTER_BORDER_COLOR"] = "%1のわくのいろ";
    Blockly.Msg["SETTER_BORDER_COLOR"] = "%1のわくのいろを%2にする";
    Blockly.Msg["GETTER_BORDER_WIDTH"] = "%1のわくのサイズ";
    Blockly.Msg["SETTER_BORDER_WIDTH"] = "%1のわくのサイズを%2にする";
    Blockly.Msg["SETTER_BORDER_WIDTH_BY_STEP"] = "%1のわくのサイズを%2ずつかえる";
    Blockly.Msg["SETTER_BORDER_WIDTH_BY_TIME"] = "%1びょうで%2のわくのサイズを%3にする";

    Blockly.Msg["GETTER_BORDER_RADIUS"] = "%1のかどのまるさ";
    Blockly.Msg["SETTER_BORDER_RADIUS"] = "%1のかどのまるさを%2にする";
    Blockly.Msg["SETTER_BORDER_RADIUS_BY_STEP"] = "%1のかどのまるさを%2ずつかえる";
    Blockly.Msg["SETTER_BORDER_RADIUS_BY_TIME"] = "%1びょうで%2のかどのまるさを%3にする";

    Blockly.Msg["GETTER_X_COORDINATE"] = "%1のXざひょう";
    Blockly.Msg["SETTER_X_COORDINATE"] = "%1のXざひょうを%2にする";
    Blockly.Msg["SETTER_X_COORDINATE_BY_STEP"] = "%1のXざひょうを%2ずつかえる";
    Blockly.Msg["SETTER_X_COORDINATE_BY_TIME"] = "%1びょうで%2のXざひょうを%3にする";
    Blockly.Msg["SETTER_X_COORDINATE_BY_STEP_TIME"] = "%1びょうで%2のXざひょうを%3ずつかえる";

    Blockly.Msg["GETTER_Y_COORDINATE"] = "%1のYざひょう";
    Blockly.Msg["SETTER_Y_COORDINATE"] = "%1のYざひょうを%2にする";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_STEP"] = "%1のYざひょうを%2ずつかえる";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_TIME"] = "%1びょうで%2のYざひょうを%3にする";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_STEP_TIME"] = "%1びょうで%2のYざひょうを%3ずつかえる";
    Blockly.Msg["SETTER_X_Y_COORDINATE"] = "%1のXざひょうを%2、Yざひょうを%3にする";
    Blockly.Msg["SETTER_X_Y_BY_TIME"] = "%1びょうで%2のXざひょうを%3、Yざひょうを%4にする";
    Blockly.Msg["SETTER_X_Y_BY_STEP_TIME"] = "%1びょうで%2のXざひょうを%3、Yざひょうを%4ずつかえる";

    Blockly.Msg["GETTER_ROTATION"] = "%1のかくど";
    Blockly.Msg["SETTER_LEFT_ROTATION"] = "%1をひだりへ%2にむける";
    Blockly.Msg["SETTER_LEFT_ROTATION_BY_STEP"] = "%1をひだりへ%2ずつまわす";
    Blockly.Msg["SETTER_LEFT_ROTATION_BY_TIME"] = "%1びょうで%2をひだりへ%3にむける";
    Blockly.Msg["SETTER_RIGHT_ROTATION"] = "%1をみぎへ%2にむける";
    Blockly.Msg["SETTER_RIGHT_ROTATION_BY_STEP"] = "%1をみぎへ%2ずつまわす";
    Blockly.Msg["SETTER_RIGHT_ROTATION_BY_TIME"] = "%1びょうで%2をみぎへ%3にむける";

    Blockly.Msg["GETTER_SCALE"] = "%1のサイズ";
    Blockly.Msg["SETTER_SCALE"] = "%1のサイズを%2ばいにする";
    Blockly.Msg["SETTER_SCALE_BY_STEP"] = "%1のサイズを%2ばいずつかえる";
    Blockly.Msg["SETTER_SCALE_BY_TIME"] = "%1びょうで%2のサイズを%3ばいにする";

    Blockly.Msg["GETTER_SHADOW_COLOR"] = "%1のかげのいろ";
    Blockly.Msg["SETTER_SHADOW_COLOR"] = "%1のかげのいろを%2にする";
    Blockly.Msg["GETTER_SHADOW_RADIUS"] = "%1のかげのサイズ";
    Blockly.Msg["SETTER_SHADOW_RADIUS"] = "%1のかげのサイズを%2にする";
    Blockly.Msg["SETTER_SHADOW_RADIUS_BY_STEP"] = "%1のかげのサイズを%2ずつかえる";
    Blockly.Msg["SETTER_SHADOW_RADIUS_BY_TIME"] = "%1びょうで%2のかげのサイズを%3にする";

    Blockly.Msg["GETTER_WIDTH"] = "%1のよこのサイズ";
    Blockly.Msg["SETTER_WIDTH"] = "%1のよこのサイズを%2にする";
    Blockly.Msg["SETTER_WIDTH_BY_STEP"] = "%1のよこのサイズを%2ずつかえる";
    Blockly.Msg["SETTER_WIDTH_BY_TIME"] = "%1びょうで%2のよこのサイズを%3にする";

    Blockly.Msg["GETTER_HEIGHT"] = "%1のたてのサイズ";
    Blockly.Msg["SETTER_HEIGHT"] = "%1のたてのサイズを%2にする";
    Blockly.Msg["SETTER_HEIGHT_BY_STEP"] = "%1のたてのサイズを%2ずつかえる";
    Blockly.Msg["SETTER_HEIGHT_BY_TIME"] = "%1びょうで%2のたてのサイズを%3にする";
    Blockly.Msg["SETTER_WIDTH_HEIGHT_BY_TIME"] =
      "%1びょうで%2のよこのサイズを%3、たてのサイズを%4にする";

    Blockly.Msg["TEXT_FONT_WEIGHT_BOLD"] = "ふとい";
    Blockly.Msg["TEXT_FONT_WEIGHT_REGULAR"] = "ふつう";
    Blockly.Msg["TEXT_FONT_WEIGHT_LIGHT"] = "ほそい";

    Blockly.Msg["GETTER_TEXT_FONT_FAMILY"] = "%1のフォント";
    Blockly.Msg["SETTER_TEXT_FONT_FAMILY"] = "%1のフォントを%2にする";
    Blockly.Msg["GETTER_TEXT_FONT_WEIGHT"] = "%1のテキストウェイト";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT"] = "%1のテキストウェイトを%2にする";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT_BY_STEP"] = "%1のテキストウェイトを%2ずつかえる";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT_BY_TIME"] = "%1びょうで%2のテキストウェイトを%3にする";
    Blockly.Msg["GETTER_TEXT_FONT_SIZE"] = "%1のフォントサイズ";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE"] = "%1のフォントサイズを%2にする";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE_BY_STEP"] = "%1のフォントサイズを%2ずつかえる";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE_BY_TIME"] = "%1びょうで%2のフォントサイズを%3にする";
    Blockly.Msg["GETTER_TEXT"] = "%1のテキスト";
    Blockly.Msg["SETTER_TEXT"] = "%1のテキストを%2にする";
    Blockly.Msg["GETTER_TEXT_COLOR"] = "%1のテキストのいろ";
    Blockly.Msg["SETTER_TEXT_COLOR"] = "%1のテキストのいろを%2にする";
    Blockly.Msg["GETTER_TEXT_SHADOW_COLOR"] = "%1のテキストのかげのいろ";
    Blockly.Msg["SETTER_TEXT_SHADOW_COLOR"] = "%1のテキストのかげのいろを%2にする";
    Blockly.Msg["GETTER_TEXT_SHADOW_RADIUS"] = "%1のテキストのかげのサイズ";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS"] = "%1のテキストのかげのサイズを%2にする";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS_BY_STEP"] = "%1のテキストのかげのサイズを%2ずつ変える";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS_BY_TIME"] =
      "%1びょうで%2のテキストのかげのサイズを%3にする";
  } else if (locale === "ja_kanji") {
    Blockly.setLocale(Jp);
    Blockly.Msg["COURSE_START_BLOCK"] = "         実行         ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_MOVE"] = "    進む    ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_LEFT"] = "    左へ    ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_RIGHT"] = "    右へ    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_MOVE"] = "    前に進む    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_LEFT"] = "    左を向く    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_RIGHT"] = "    右を向く    ";
    Blockly.Msg["COURSE_TANGIBLE_REPEAT"] = "繰り返す　　　　条件";
    Blockly.Msg["COURSE_TANGIBLE_IF"] = "もし　　　　条件";
    Blockly.Msg["COURSE_ALGORITHM_REPEAT"] = "回繰り返す";
    Blockly.Msg["COURSE_ALGORITHM_WHILE_UNTIL"] = "色まで繰り返す";

    Blockly.Msg["COURSE_PROGRAM_CLOCK_HOUR"] = "時計の時間を%1時にする";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_MINUTE"] = "時計の時間を%1分にする";
    Blockly.Msg["COURSE_PROGRAM_CLOCK"] = "時計の時間を%1時%2分にする";
    Blockly.Msg["COURSE_PROGRAM_SETTER_X_COORDINATE"] = "%1のX座標を%2に移動する";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_SHOT_HAND"] = "短い針";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_LONG_HAND"] = "長い針";

    Blockly.Msg["GETTER_VALUE"] = "%1の値";

    Blockly.Msg["UNNAMED_KEY"] = "名前なし";
    Blockly.Msg["CUSTOM_VARIABLE_DEFAULT_NAME"] = "変数";
    Blockly.Msg["DELETE_X_BLOCKS"] = "ブロックを削除する";
    Blockly.Msg["RENAME_VARIABLE"] = "変数の名前をかえる…";
    Blockly.Msg["RENAME_VARIABLE_TITLE"] = `"%1"の名前をかえる：`;

    Blockly.Msg["DEFAULT_COMPONENT"] = "パーツ";
    Blockly.Msg["EVENT_CLICK"] = "を押したとき";
    Blockly.Msg["DISPLAY_EVENT"] = "を表示する";

    Blockly.Msg["SCREEN_EVENT_LOADING"] = "が表示されたとき";
    Blockly.Msg["SCREEN_EVENT_NAVIGATE"] = "へ移動";
    Blockly.Msg["SCREEN_GETTER_BACKGROUND_COLOR"] = "の背景の色";
    Blockly.Msg["SCREEN_SETTER_BACKGROUND_COLOR"] = "の背景の色を";

    Blockly.Msg["TOGGLE_GETTER_VALUE"] = "%1の値";
    Blockly.Msg["TOGGLE_SETTER_VALUE"] = "%1の値を%2にする";

    Blockly.Msg["CHECKBOX_EVENT_CHECK"] = "がチェックされたとき";
    Blockly.Msg["SWITCH_EVENT_VALUE_CHANGE"] = "のが変わった時";

    Blockly.Msg["TEXTINPUT_EVENT_VALUE_CHANGE"] = "が入力されたとき";
    Blockly.Msg["TEXTINPUT_GETTER_VALUE"] = "%1が入力された値";
    Blockly.Msg["TEXTINPUT_SETTER_VALUE"] = "%1の値を%2にする";

    Blockly.Msg["IMAGE_SETTER_SRC"] = "%1の画像を%2にする";

    Blockly.Msg["DISPLAY_ORDER"] = "の表示を";
    Blockly.Msg["DISPLAY_ORDER_TOP"] = "一番上";
    Blockly.Msg["DISPLAY_ORDER_BOTTOM"] = "一番下";

    Blockly.Msg["GETTER_OPACITY"] = "%1の透明度";
    Blockly.Msg["SETTER_OPACITY"] = "%1の透明度を%2にする";
    Blockly.Msg["SETTER_OPACITY_BY_STEP"] = "%1透明度を%2ずつ変える";
    Blockly.Msg["SETTER_OPACITY_BY_TIME"] = "%1秒で%2の透明度を%3にする";

    Blockly.Msg["GETTER_BACKGROUND_COLOR"] = "%1の背景の色";
    Blockly.Msg["SETTER_BACKGROUND_COLOR"] = "%1の背景の色を%2にする";

    Blockly.Msg["GETTER_BORDER_COLOR"] = "%1の枠の色";
    Blockly.Msg["SETTER_BORDER_COLOR"] = "%1の枠の色を%2にする";
    Blockly.Msg["GETTER_BORDER_WIDTH"] = "%1の枠のサイズ";
    Blockly.Msg["SETTER_BORDER_WIDTH"] = "%1の枠のサイズを%2にする";
    Blockly.Msg["SETTER_BORDER_WIDTH_BY_STEP"] = "%1の枠のサイズを%2ずつ変える";
    Blockly.Msg["SETTER_BORDER_WIDTH_BY_TIME"] = "%1秒で%2の枠のサイズを%3にする";

    Blockly.Msg["GETTER_BORDER_RADIUS"] = "%1の角の丸さ";
    Blockly.Msg["SETTER_BORDER_RADIUS"] = "%1の角の丸さを%2にする";
    Blockly.Msg["SETTER_BORDER_RADIUS_BY_STEP"] = "%1の角の丸さを%2ずつ変える";
    Blockly.Msg["SETTER_BORDER_RADIUS_BY_TIME"] = "%1秒で%2の角の丸さを%3にする";

    Blockly.Msg["GETTER_X_COORDINATE"] = "%1のX座標";
    Blockly.Msg["SETTER_X_COORDINATE"] = "%1のX座標を%2にする";
    Blockly.Msg["SETTER_X_COORDINATE_BY_STEP"] = "%1のX座標を%2ずつ変える";
    Blockly.Msg["SETTER_X_COORDINATE_BY_TIME"] = "%1秒で%2のX座標を%3にする";
    Blockly.Msg["SETTER_X_COORDINATE_BY_STEP_TIME"] = "%1秒で%2のX座標を%3ずつ変える";

    Blockly.Msg["GETTER_Y_COORDINATE"] = "%1のY座標";
    Blockly.Msg["SETTER_Y_COORDINATE"] = "%1のY座標を%2にする";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_STEP"] = "%1のY座標を%2ずつ変える";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_TIME"] = "%1秒で%2のY座標を%3にする";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_STEP_TIME"] = "%1秒で%2のY座標を%3ずつ変える";
    Blockly.Msg["SETTER_X_Y_COORDINATE"] = "%1のX座標を%2、Y座標を%3にする";
    Blockly.Msg["SETTER_X_Y_BY_TIME"] = "%1秒で%2のX座標を%3、Y座標を%4にする";
    Blockly.Msg["SETTER_X_Y_BY_STEP_TIME"] = "%1秒で%2のX座標を%3、Y座標を%4ずつ変える";

    Blockly.Msg["GETTER_ROTATION"] = "%1の角度";
    Blockly.Msg["SETTER_LEFT_ROTATION"] = "%1を左へ%2に向ける";
    Blockly.Msg["SETTER_LEFT_ROTATION_BY_STEP"] = "%1を左へ%2ずつ回す";
    Blockly.Msg["SETTER_LEFT_ROTATION_BY_TIME"] = "%1秒で%2を左へ%3に向ける";
    Blockly.Msg["SETTER_RIGHT_ROTATION"] = "%1を右へ%2に向ける";
    Blockly.Msg["SETTER_RIGHT_ROTATION_BY_STEP"] = "%1を右へ%2ずつ回す";
    Blockly.Msg["SETTER_RIGHT_ROTATION_BY_TIME"] = "%1秒で%2を右へ%3に向ける";

    Blockly.Msg["GETTER_SCALE"] = "%1のサイズ";
    Blockly.Msg["SETTER_SCALE"] = "%1のサイズを%2倍にする";
    Blockly.Msg["SETTER_SCALE_BY_STEP"] = "%1のサイズを%2倍ずつ変える";
    Blockly.Msg["SETTER_SCALE_BY_TIME"] = "%1秒で%2のサイズを%3倍にする";

    Blockly.Msg["GETTER_SHADOW_COLOR"] = "%1の影の色";
    Blockly.Msg["SETTER_SHADOW_COLOR"] = "%1の影の色を%2にする";
    Blockly.Msg["GETTER_SHADOW_RADIUS"] = "%1の影のサイズ";
    Blockly.Msg["SETTER_SHADOW_RADIUS"] = "%1の影のサイズを%2にする";
    Blockly.Msg["SETTER_SHADOW_RADIUS_BY_STEP"] = "%1の影のサイズを%2ずつ変える";
    Blockly.Msg["SETTER_SHADOW_RADIUS_BY_TIME"] = "%1秒で%2の影のサイズを%3にする";

    Blockly.Msg["GETTER_WIDTH"] = "%1の横のサイズ";
    Blockly.Msg["SETTER_WIDTH"] = "%1の横のサイズを%2にする";
    Blockly.Msg["SETTER_WIDTH_BY_STEP"] = "%1の横のサイズを%2ずつ変える";
    Blockly.Msg["SETTER_WIDTH_BY_TIME"] = "%1秒で%2の横のサイズを%3にする";

    Blockly.Msg["GETTER_HEIGHT"] = "%1の縦のサイズ";
    Blockly.Msg["SETTER_HEIGHT"] = "%1の縦のサイズを%2にする";
    Blockly.Msg["SETTER_HEIGHT_BY_STEP"] = "%1の縦のサイズを%2ずつ変える";
    Blockly.Msg["SETTER_HEIGHT_BY_TIME"] = "%1秒で%2の縦のサイズを%3にする";
    Blockly.Msg["SETTER_WIDTH_HEIGHT_BY_TIME"] = "%1秒で%2の横サイズを%3、縦サイズを%4にする";

    Blockly.Msg["TEXT_FONT_WEIGHT_BOLD"] = "太い";
    Blockly.Msg["TEXT_FONT_WEIGHT_REGULAR"] = "普通";
    Blockly.Msg["TEXT_FONT_WEIGHT_LIGHT"] = "細い";

    Blockly.Msg["GETTER_TEXT_FONT_FAMILY"] = "%1のフォント";
    Blockly.Msg["SETTER_TEXT_FONT_FAMILY"] = "%1のフォントを%2にする";
    Blockly.Msg["GETTER_TEXT_FONT_WEIGHT"] = "%1のテキストウェイト";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT"] = "%1のテキストウェイトを%2にする";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT_BY_STEP"] = "%1のテキストウェイトを%2ずつ変える";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT_BY_TIME"] = "%1秒で%2のテキストウェイトを%3にする";
    Blockly.Msg["GETTER_TEXT_FONT_SIZE"] = "%1のフォントサイズ";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE"] = "%1のフォントサイズを%2にする";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE_BY_STEP"] = "%1のフォントサイズを%2ずつ変える";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE_BY_TIME"] = "%1秒で%2のフォントサイズを%3にする";
    Blockly.Msg["GETTER_TEXT"] = "%1のテキスト";
    Blockly.Msg["SETTER_TEXT"] = "%1のテキストを%2にする";
    Blockly.Msg["GETTER_TEXT_COLOR"] = "%1のテキストの色";
    Blockly.Msg["SETTER_TEXT_COLOR"] = "%1のテキストの色を%2にする";
    Blockly.Msg["GETTER_TEXT_SHADOW_COLOR"] = "%1のテキストの影の色";
    Blockly.Msg["SETTER_TEXT_SHADOW_COLOR"] = "%1のテキストの影の色を%2にする";
    Blockly.Msg["GETTER_TEXT_SHADOW_RADIUS"] = "%1のテキストの影のサイズ";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS"] = "%1のテキストの影のサイズを%2にする";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS_BY_STEP"] = "%1のテキストの影のサイズを%2ずつ変える";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS_BY_TIME"] = "%1秒で%2のテキストの影のサイズを%3にする";
  } else if (locale === "zh_tw") {
    Blockly.setLocale(Zh);
    Blockly.Msg["COURSE_START_BLOCK"] = "         執行         ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_MOVE"] = "    前進    ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_LEFT"] = "    左轉    ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_RIGHT"] = "    右轉    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_MOVE"] = "    向前移動    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_LEFT"] = "    向左轉    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_RIGHT"] = "    向右轉    ";
    Blockly.Msg["COURSE_TANGIBLE_REPEAT"] = "重複　　　　條件";
    Blockly.Msg["COURSE_TANGIBLE_IF"] = "如果　　　　條件";
    Blockly.Msg["COURSE_ALGORITHM_REPEAT"] = "次重複";
    Blockly.Msg["COURSE_ALGORITHM_WHILE_UNTIL"] = "顏色直到重複";

    Blockly.Msg["COURSE_PROGRAM_CLOCK_HOUR"] = "時鐘時間設為%1時";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_MINUTE"] = "時鐘時間設為%1分";
    Blockly.Msg["COURSE_PROGRAM_CLOCK"] = "時鐘時間設為%1時%2分";
    Blockly.Msg["COURSE_PROGRAM_SETTER_X_COORDINATE"] = "%1的X座標移動到%2";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_SHOT_HAND"] = "短針";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_LONG_HAND"] = "長針";

    Blockly.Msg["GETTER_VALUE"] = "%1的值";
    Blockly.Msg["UNNAMED_KEY"] = "未命名";
    Blockly.Msg["CUSTOM_VARIABLE_DEFAULT_NAME"] = "變數";
    Blockly.Msg["DELETE_X_BLOCKS"] = "刪除區塊";
    Blockly.Msg["RENAME_VARIABLE"] = "重新命名變數...";
    Blockly.Msg["RENAME_VARIABLE_TITLE"] = "重新命名「%1」：";

    Blockly.Msg["DEFAULT_COMPONENT"] = "元件";
    Blockly.Msg["EVENT_CLICK"] = "點擊時";
    Blockly.Msg["DISPLAY_EVENT"] = "顯示時";

    Blockly.Msg["SCREEN_EVENT_LOADING"] = "被顯示時";
    Blockly.Msg["SCREEN_EVENT_NAVIGATE"] = "移動到";
    Blockly.Msg["SCREEN_GETTER_BACKGROUND_COLOR"] = "背景色";
    Blockly.Msg["SCREEN_SETTER_BACKGROUND_COLOR"] = "背景色為";

    Blockly.Msg["TOGGLE_GETTER_VALUE"] = "%1的值";
    Blockly.Msg["TOGGLE_SETTER_VALUE"] = "%1的值為%2";

    Blockly.Msg["CHECKBOX_EVENT_CHECK"] = "被勾選時";
    Blockly.Msg["SWITCH_EVENT_VALUE_CHANGE"] = "被更改時";

    Blockly.Msg["TEXTINPUT_EVENT_VALUE_CHANGE"] = "被輸入時";
    Blockly.Msg["TEXTINPUT_GETTER_VALUE"] = "%1被輸入的值";
    Blockly.Msg["TEXTINPUT_SETTER_VALUE"] = "%1的值為%2";

    Blockly.Msg["IMAGE_SETTER_SRC"] = "%1的圖像為%2";

    Blockly.Msg["DISPLAY_ORDER"] = "顯示順序為";
    Blockly.Msg["DISPLAY_ORDER_TOP"] = "最上層";
    Blockly.Msg["DISPLAY_ORDER_BOTTOM"] = "最下層";

    Blockly.Msg["GETTER_OPACITY"] = "%1的透明度";
    Blockly.Msg["SETTER_OPACITY"] = "%1的透明度為%2";
    Blockly.Msg["SETTER_OPACITY_BY_STEP"] = "%1透明度為%2每步變化";
    Blockly.Msg["SETTER_OPACITY_BY_TIME"] = "%1秒內%2的透明度為%3";

    Blockly.Msg["GETTER_BACKGROUND_COLOR"] = "%1的背景色";
    Blockly.Msg["SETTER_BACKGROUND_COLOR"] = "%1的背景色為%2";

    Blockly.Msg["GETTER_BORDER_COLOR"] = "%1的框色";
    Blockly.Msg["SETTER_BORDER_COLOR"] = "%1的框色為%2";
    Blockly.Msg["GETTER_BORDER_WIDTH"] = "%1的框尺寸";
    Blockly.Msg["SETTER_BORDER_WIDTH"] = "%1的框尺寸為%2";
    Blockly.Msg["SETTER_BORDER_WIDTH_BY_STEP"] = "%1的框尺寸為%2每步變化";
    Blockly.Msg["SETTER_BORDER_WIDTH_BY_TIME"] = "%1秒內%2的框尺寸為%3";

    Blockly.Msg["GETTER_BORDER_RADIUS"] = "%1的角圓度";
    Blockly.Msg["SETTER_BORDER_RADIUS"] = "%1的角圓度為%2";
    Blockly.Msg["SETTER_BORDER_RADIUS_BY_STEP"] = "%1的角圓度為%2每步變化";
    Blockly.Msg["SETTER_BORDER_RADIUS_BY_TIME"] = "%1秒內%2的角圓度為%3";

    Blockly.Msg["GETTER_X_COORDINATE"] = "%1的X座標";
    Blockly.Msg["SETTER_X_COORDINATE"] = "%1的X座標為%2";
    Blockly.Msg["SETTER_X_COORDINATE_BY_STEP"] = "%1的X座標為%2每步變化";
    Blockly.Msg["SETTER_X_COORDINATE_BY_TIME"] = "%1秒內%2的X座標為%3";
    Blockly.Msg["SETTER_X_COORDINATE_BY_STEP_TIME"] = "%1秒內%2的X座標為%3每步變化";

    Blockly.Msg["GETTER_Y_COORDINATE"] = "%1的Y座標";
    Blockly.Msg["SETTER_Y_COORDINATE"] = "%1的Y座標為%2";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_STEP"] = "%1的Y座標為%2每步變化";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_TIME"] = "%1秒內%2的Y座標為%3";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_STEP_TIME"] = "%1秒內%2的Y座標為%3每步變化";
    Blockly.Msg["SETTER_X_Y_COORDINATE"] = "%1的X座標為%2、Y座標為%3";
    Blockly.Msg["SETTER_X_Y_BY_TIME"] = "%1秒內%2的X座標為%3、Y座標為%4";
    Blockly.Msg["SETTER_X_Y_BY_STEP_TIME"] = "%1秒內%2的X座標為%3、Y座標為%4每步變化";

    Blockly.Msg["GETTER_ROTATION"] = "%1的角度";
    Blockly.Msg["SETTER_LEFT_ROTATION"] = "%1向左轉%2度";
    Blockly.Msg["SETTER_LEFT_ROTATION_BY_STEP"] = "%1向左轉%2度每步旋轉";
    Blockly.Msg["SETTER_LEFT_ROTATION_BY_TIME"] = "%1秒內%2向左轉%3度";
    Blockly.Msg["SETTER_RIGHT_ROTATION"] = "%1向右轉%2度";
    Blockly.Msg["SETTER_RIGHT_ROTATION_BY_STEP"] = "%1向右轉%2度每步旋轉";
    Blockly.Msg["SETTER_RIGHT_ROTATION_BY_TIME"] = "%1秒內%2向右轉%3度";

    Blockly.Msg["GETTER_SCALE"] = "%1的尺寸";
    Blockly.Msg["SETTER_SCALE"] = "%1的尺寸為%2倍";
    Blockly.Msg["SETTER_SCALE_BY_STEP"] = "%1的尺寸為%2倍每步變化";
    Blockly.Msg["SETTER_SCALE_BY_TIME"] = "%1秒內%2的尺寸為%3倍";

    Blockly.Msg["GETTER_SHADOW_COLOR"] = "%1的陰影色";
    Blockly.Msg["SETTER_SHADOW_COLOR"] = "%1的陰影色為%2";
    Blockly.Msg["GETTER_SHADOW_RADIUS"] = "%1的陰影尺寸";
    Blockly.Msg["SETTER_SHADOW_RADIUS"] = "%1的陰影尺寸為%2";
    Blockly.Msg["SETTER_SHADOW_RADIUS_BY_STEP"] = "%1的陰影尺寸為%2每步變化";
    Blockly.Msg["SETTER_SHADOW_RADIUS_BY_TIME"] = "%1秒內%2的陰影尺寸為%3";

    Blockly.Msg["GETTER_WIDTH"] = "%1的橫尺寸";
    Blockly.Msg["SETTER_WIDTH"] = "%1的橫尺寸為%2";
    Blockly.Msg["SETTER_WIDTH_BY_STEP"] = "%1的橫尺寸為%2每步變化";
    Blockly.Msg["SETTER_WIDTH_BY_TIME"] = "%1秒內%2的橫尺寸為%3";

    Blockly.Msg["GETTER_HEIGHT"] = "%1的直尺寸";
    Blockly.Msg["SETTER_HEIGHT"] = "%1的直尺寸為%2";
    Blockly.Msg["SETTER_HEIGHT_BY_STEP"] = "%1的直尺寸為%2每步變化";
    Blockly.Msg["SETTER_HEIGHT_BY_TIME"] = "%1秒內%2的直尺寸為%3";
    Blockly.Msg["SETTER_WIDTH_HEIGHT_BY_TIME"] = "%1秒內%2的橫尺寸為%3、直尺寸為%4";

    Blockly.Msg["TEXT_FONT_WEIGHT_BOLD"] = "粗體";
    Blockly.Msg["TEXT_FONT_WEIGHT_REGULAR"] = "普通";
    Blockly.Msg["TEXT_FONT_WEIGHT_LIGHT"] = "細體";

    Blockly.Msg["GETTER_TEXT_FONT_FAMILY"] = "%1的字體";
    Blockly.Msg["SETTER_TEXT_FONT_FAMILY"] = "%1的字體為%2";
    Blockly.Msg["GETTER_TEXT_FONT_WEIGHT"] = "%1的文字重量";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT"] = "%1的文字重量為%2";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT_BY_STEP"] = "%1的文字重量為%2每步變化";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT_BY_TIME"] = "%1秒內%2的文字重量為%3";
    Blockly.Msg["GETTER_TEXT_FONT_SIZE"] = "%1的字體尺寸";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE"] = "%1的字體尺寸為%2";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE_BY_STEP"] = "%1的字體尺寸為%2每步變化";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE_BY_TIME"] = "%1秒內%2的字體尺寸為%3";
    Blockly.Msg["GETTER_TEXT"] = "%1的文字";
    Blockly.Msg["SETTER_TEXT"] = "%1的文字為%2";
    Blockly.Msg["GETTER_TEXT_COLOR"] = "%1的文字顏色";
    Blockly.Msg["SETTER_TEXT_COLOR"] = "%1的文字顏色為%2";
    Blockly.Msg["GETTER_TEXT_SHADOW_COLOR"] = "%1的文字陰影顏色";
    Blockly.Msg["SETTER_TEXT_SHADOW_COLOR"] = "%1的文字陰影顏色為%2";
    Blockly.Msg["GETTER_TEXT_SHADOW_RADIUS"] = "%1的文字陰影尺寸";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS"] = "%1的文字陰影尺寸為%2";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS_BY_STEP"] = "%1的文字陰影尺寸為%2每步變化";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS_BY_TIME"] = "%1秒內%2的文字陰影尺寸為%3";
  } else if (locale === "zh_cn") {
    Blockly.setLocale(ZhCn);
    Blockly.Msg["COURSE_START_BLOCK"] = "         执行         ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_MOVE"] = "    前进    ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_LEFT"] = "    左转    ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_RIGHT"] = "    右转    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_MOVE"] = "    向前移动    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_LEFT"] = "    向左转    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_RIGHT"] = "    向右转    ";
    Blockly.Msg["COURSE_TANGIBLE_REPEAT"] = "重复　　　　条件";
    Blockly.Msg["COURSE_TANGIBLE_IF"] = "如果　　　　条件";
    Blockly.Msg["COURSE_ALGORITHM_REPEAT"] = "次重复";
    Blockly.Msg["COURSE_ALGORITHM_WHILE_UNTIL"] = "颜色直到重复";

    Blockly.Msg["COURSE_PROGRAM_CLOCK_HOUR"] = "时钟时间设为%1时";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_MINUTE"] = "时钟时间设为%1分";
    Blockly.Msg["COURSE_PROGRAM_CLOCK"] = "时钟时间设为%1时%2分";
    Blockly.Msg["COURSE_PROGRAM_SETTER_X_COORDINATE"] = "%1的X坐标移动到%2";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_SHOT_HAND"] = "短针";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_LONG_HAND"] = "长针";

    Blockly.Msg["GETTER_VALUE"] = "%1的值";
    Blockly.Msg["UNNAMED_KEY"] = "未命名";
    Blockly.Msg["CUSTOM_VARIABLE_DEFAULT_NAME"] = "变量";
    Blockly.Msg["DELETE_X_BLOCKS"] = "删除区块";
    Blockly.Msg["RENAME_VARIABLE"] = "重命名变量...";
    Blockly.Msg["RENAME_VARIABLE_TITLE"] = "重命名「%1」：";

    Blockly.Msg["DEFAULT_COMPONENT"] = "组件";
    Blockly.Msg["EVENT_CLICK"] = "点击时";
    Blockly.Msg["DISPLAY_EVENT"] = "显示时";

    Blockly.Msg["SCREEN_EVENT_LOADING"] = "被显示时";
    Blockly.Msg["SCREEN_EVENT_NAVIGATE"] = "移动到";
    Blockly.Msg["SCREEN_GETTER_BACKGROUND_COLOR"] = "背景色";
    Blockly.Msg["SCREEN_SETTER_BACKGROUND_COLOR"] = "背景色为";

    Blockly.Msg["TOGGLE_GETTER_VALUE"] = "%1的值";
    Blockly.Msg["TOGGLE_SETTER_VALUE"] = "%1的值为%2";

    Blockly.Msg["CHECKBOX_EVENT_CHECK"] = "被勾选时";
    Blockly.Msg["SWITCH_EVENT_VALUE_CHANGE"] = "被更改时";

    Blockly.Msg["TEXTINPUT_EVENT_VALUE_CHANGE"] = "被输入时";
    Blockly.Msg["TEXTINPUT_GETTER_VALUE"] = "%1被输入的值";
    Blockly.Msg["TEXTINPUT_SETTER_VALUE"] = "%1的值为%2";

    Blockly.Msg["IMAGE_SETTER_SRC"] = "%1的图像为%2";

    Blockly.Msg["DISPLAY_ORDER"] = "的显示为";
    Blockly.Msg["DISPLAY_ORDER_TOP"] = "最上层";
    Blockly.Msg["DISPLAY_ORDER_BOTTOM"] = "最下层";

    Blockly.Msg["GETTER_OPACITY"] = "%1的透明度";
    Blockly.Msg["SETTER_OPACITY"] = "%1的透明度为%2";
    Blockly.Msg["SETTER_OPACITY_BY_STEP"] = "%1透明度为%2每步变化";
    Blockly.Msg["SETTER_OPACITY_BY_TIME"] = "%1秒内%2的透明度为%3";

    Blockly.Msg["GETTER_BACKGROUND_COLOR"] = "%1的背景色";
    Blockly.Msg["SETTER_BACKGROUND_COLOR"] = "%1的背景色为%2";

    Blockly.Msg["GETTER_BORDER_COLOR"] = "%1的框色";
    Blockly.Msg["SETTER_BORDER_COLOR"] = "%1的框色为%2";
    Blockly.Msg["GETTER_BORDER_WIDTH"] = "%1的框尺寸";
    Blockly.Msg["SETTER_BORDER_WIDTH"] = "%1的框尺寸为%2";
    Blockly.Msg["SETTER_BORDER_WIDTH_BY_STEP"] = "%1的框尺寸为%2每步变化";
    Blockly.Msg["SETTER_BORDER_WIDTH_BY_TIME"] = "%1秒内%2的框尺寸为%3";

    Blockly.Msg["GETTER_BORDER_RADIUS"] = "%1的角圆度";
    Blockly.Msg["SETTER_BORDER_RADIUS"] = "%1的角圆度为%2";
    Blockly.Msg["SETTER_BORDER_RADIUS_BY_STEP"] = "%1的角圆度为%2每步变化";
    Blockly.Msg["SETTER_BORDER_RADIUS_BY_TIME"] = "%1秒内%2的角圆度为%3";

    Blockly.Msg["GETTER_X_COORDINATE"] = "%1的X坐标";
    Blockly.Msg["SETTER_X_COORDINATE"] = "%1的X坐标为%2";
    Blockly.Msg["SETTER_X_COORDINATE_BY_STEP"] = "%1的X坐标为%2每步变化";
    Blockly.Msg["SETTER_X_COORDINATE_BY_TIME"] = "%1秒内%2的X坐标为%3";
    Blockly.Msg["SETTER_X_COORDINATE_BY_STEP_TIME"] = "%1秒内%2的X坐标为%3每步变化";

    Blockly.Msg["GETTER_Y_COORDINATE"] = "%1的Y坐标";
    Blockly.Msg["SETTER_Y_COORDINATE"] = "%1的Y坐标为%2";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_STEP"] = "%1的Y坐标为%2每步变化";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_TIME"] = "%1秒内%2的Y坐标为%3";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_STEP_TIME"] = "%1秒内%2的Y坐标为%3每步变化";
    Blockly.Msg["SETTER_X_Y_COORDINATE"] = "%1的X坐标为%2、Y坐标为%3";
    Blockly.Msg["SETTER_X_Y_BY_TIME"] = "%1秒内%2的X坐标为%3、Y坐标为%4";
    Blockly.Msg["SETTER_X_Y_BY_STEP_TIME"] = "%1秒内%2的X坐标为%3、Y坐标为%4每步变化";

    Blockly.Msg["GETTER_ROTATION"] = "%1的角度";
    Blockly.Msg["SETTER_LEFT_ROTATION"] = "%1向左转%2度";
    Blockly.Msg["SETTER_LEFT_ROTATION_BY_STEP"] = "%1向左转%2度每步旋转";
    Blockly.Msg["SETTER_LEFT_ROTATION_BY_TIME"] = "%1秒内%2向左转%3度";
    Blockly.Msg["SETTER_RIGHT_ROTATION"] = "%1向右转%2度";
    Blockly.Msg["SETTER_RIGHT_ROTATION_BY_STEP"] = "%1向右转%2度每步旋转";
    Blockly.Msg["SETTER_RIGHT_ROTATION_BY_TIME"] = "%1秒内%2向右转%3度";

    Blockly.Msg["GETTER_SCALE"] = "%1的尺寸";
    Blockly.Msg["SETTER_SCALE"] = "%1的尺寸为%2倍";
    Blockly.Msg["SETTER_SCALE_BY_STEP"] = "%1的尺寸为%2倍每步变化";
    Blockly.Msg["SETTER_SCALE_BY_TIME"] = "%1秒内%2的尺寸为%3倍";

    Blockly.Msg["GETTER_SHADOW_COLOR"] = "%1的阴影色";
    Blockly.Msg["SETTER_SHADOW_COLOR"] = "%1的阴影色为%2";
    Blockly.Msg["GETTER_SHADOW_RADIUS"] = "%1的阴影尺寸";
    Blockly.Msg["SETTER_SHADOW_RADIUS"] = "%1的阴影尺寸為%2";
    Blockly.Msg["SETTER_SHADOW_RADIUS_BY_STEP"] = "%1的阴影尺寸為%2每步變化";
    Blockly.Msg["SETTER_SHADOW_RADIUS_BY_TIME"] = "%1秒內%2的陰影尺寸為%3";

    Blockly.Msg["GETTER_WIDTH"] = "%1的橫尺寸";
    Blockly.Msg["SETTER_WIDTH"] = "%1的橫尺寸為%2";
    Blockly.Msg["SETTER_WIDTH_BY_STEP"] = "%1的橫尺寸為%2每步變化";
    Blockly.Msg["SETTER_WIDTH_BY_TIME"] = "%1秒內%2的橫尺寸為%3";

    Blockly.Msg["GETTER_HEIGHT"] = "%1的直尺寸";
    Blockly.Msg["SETTER_HEIGHT"] = "%1的直尺寸為%2";
    Blockly.Msg["SETTER_HEIGHT_BY_STEP"] = "%1的直尺寸為%2每步變化";
    Blockly.Msg["SETTER_HEIGHT_BY_TIME"] = "%1秒內%2的直尺寸為%3";
    Blockly.Msg["SETTER_WIDTH_HEIGHT_BY_TIME"] = "%1秒內%2的橫尺寸為%3、直尺寸為%4";

    Blockly.Msg["TEXT_FONT_WEIGHT_BOLD"] = "粗體";
    Blockly.Msg["TEXT_FONT_WEIGHT_REGULAR"] = "普通";
    Blockly.Msg["TEXT_FONT_WEIGHT_LIGHT"] = "細體";

    Blockly.Msg["GETTER_TEXT_FONT_FAMILY"] = "%1的字體";
    Blockly.Msg["SETTER_TEXT_FONT_FAMILY"] = "%1的字體為%2";
    Blockly.Msg["GETTER_TEXT_FONT_WEIGHT"] = "%1的文字重量";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT"] = "%1的文字重量為%2";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT_BY_STEP"] = "%1的文字重量為%2每步變化";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT_BY_TIME"] = "%1秒內%2的文字重量為%3";
    Blockly.Msg["GETTER_TEXT_FONT_SIZE"] = "%1的字體尺寸";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE"] = "%1的字體尺寸為%2";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE_BY_STEP"] = "%1的字體尺寸為%2每步變化";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE_BY_TIME"] = "%1秒內%2的字體尺寸為%3";
    Blockly.Msg["GETTER_TEXT"] = "%1的文字";
    Blockly.Msg["SETTER_TEXT"] = "%1的文字為%2";
    Blockly.Msg["GETTER_TEXT_COLOR"] = "%1的文字顏色";
    Blockly.Msg["SETTER_TEXT_COLOR"] = "%1的文字顏色為%2";
    Blockly.Msg["GETTER_TEXT_SHADOW_COLOR"] = "%1的文字陰影顏色";
    Blockly.Msg["SETTER_TEXT_SHADOW_COLOR"] = "%1的文字陰影顏色為%2";
    Blockly.Msg["GETTER_TEXT_SHADOW_RADIUS"] = "%1的文字陰影尺寸";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS"] = "%1的文字陰影尺寸為%2";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS_BY_STEP"] = "%1的文字陰影尺寸為%2每步變化";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS_BY_TIME"] = "%1秒內%2的文字陰影尺寸為%3";
  } else if (locale === "en") {
    Blockly.setLocale(En);
    // Start English Translations based on ja_kanji
    Blockly.Msg["COURSE_START_BLOCK"] = "         Execute         ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_MOVE"] = "    Move Forward    ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_LEFT"] = "    Turn Left    ";
    Blockly.Msg["COURSE_ALGORITHM_DIRECTION_RIGHT"] = "    Turn Right    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_MOVE"] = "    Move Forward    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_LEFT"] = "    Turn Left    ";
    Blockly.Msg["COURSE_TANGIBLE_DIRECTION_RIGHT"] = "    Turn Right    ";
    Blockly.Msg["COURSE_TANGIBLE_REPEAT"] = "Repeat　　　　Condition"; // Kept original spacing for layout consistency if needed
    Blockly.Msg["COURSE_TANGIBLE_IF"] = "If　　　　Condition"; // Kept original spacing
    Blockly.Msg["COURSE_ALGORITHM_REPEAT"] = " Repeat Times"; // Note: Leading space added to match ja_kanji formatting
    Blockly.Msg["COURSE_ALGORITHM_WHILE_UNTIL"] = "Repeat Until Color";

    Blockly.Msg["COURSE_PROGRAM_CLOCK_HOUR"] = "Set clock time to %1 hour";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_MINUTE"] = "Set clock time to %1 minute";
    Blockly.Msg["COURSE_PROGRAM_CLOCK"] = "Set clock time to %1 hour %2 minute";
    Blockly.Msg["COURSE_PROGRAM_SETTER_X_COORDINATE"] = "Move %1's X coordinate to %2";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_SHOT_HAND"] = "Short Hand";
    Blockly.Msg["COURSE_PROGRAM_CLOCK_LONG_HAND"] = "Long Hand";

    Blockly.Msg["GETTER_VALUE"] = "%1's Value";

    Blockly.Msg["UNNAMED_KEY"] = "Unnamed";
    Blockly.Msg["CUSTOM_VARIABLE_DEFAULT_NAME"] = "Variable";
    // Inherited from 'ja' section, assuming 'DELETE_BLOCK' and 'DELETE_X_BLOCKS' should be the same or similar
    Blockly.Msg["DELETE_X_BLOCKS"] = "Delete Blocks";
    Blockly.Msg["RENAME_VARIABLE"] = "Rename variable...";
    Blockly.Msg["RENAME_VARIABLE_TITLE"] = "Rename variable '%1' to:"; // Adjusted format slightly for English convention

    Blockly.Msg["DEFAULT_COMPONENT"] = "Component";
    Blockly.Msg["EVENT_CLICK"] = " when clicked"; // Note: Changed structure for natural English
    Blockly.Msg["DISPLAY_EVENT"] = " display"; // Note: Changed structure for natural English

    Blockly.Msg["SCREEN_EVENT_LOADING"] = " when displayed"; // Note: Changed structure for natural English
    Blockly.Msg["SCREEN_EVENT_NAVIGATE"] = " navigate to"; // Note: Changed structure for natural English
    Blockly.Msg["SCREEN_GETTER_BACKGROUND_COLOR"] = "'s background color";
    Blockly.Msg["SCREEN_SETTER_BACKGROUND_COLOR"] = "'s background color to";

    Blockly.Msg["TOGGLE_GETTER_VALUE"] = "%1's value";
    Blockly.Msg["TOGGLE_SETTER_VALUE"] = "set %1's value to %2";

    Blockly.Msg["CHECKBOX_EVENT_CHECK"] = " when checked"; // Note: Changed structure for natural English
    Blockly.Msg["SWITCH_EVENT_VALUE_CHANGE"] = "'s value changes"; // Note: Changed structure for natural English

    Blockly.Msg["TEXTINPUT_EVENT_VALUE_CHANGE"] = " when text entered"; // Note: Changed structure for natural English
    Blockly.Msg["TEXTINPUT_GETTER_VALUE"] = "text input value of %1";
    Blockly.Msg["TEXTINPUT_SETTER_VALUE"] = "set %1's value to %2";

    Blockly.Msg["IMAGE_SETTER_SRC"] = "set %1's image to %2";

    Blockly.Msg["DISPLAY_ORDER"] = "display order of ";
    Blockly.Msg["DISPLAY_ORDER_TOP"] = "Top";
    Blockly.Msg["DISPLAY_ORDER_BOTTOM"] = "Bottom";

    Blockly.Msg["GETTER_OPACITY"] = "%1's Opacity";
    Blockly.Msg["SETTER_OPACITY"] = "set %1's Opacity to %2";
    Blockly.Msg["SETTER_OPACITY_BY_STEP"] = "change %1's Opacity by %2";
    Blockly.Msg["SETTER_OPACITY_BY_TIME"] = "in %1 seconds set %2's Opacity to %3";

    Blockly.Msg["GETTER_BACKGROUND_COLOR"] = "%1's Background Color";
    Blockly.Msg["SETTER_BACKGROUND_COLOR"] = "set %1's Background Color to %2";

    Blockly.Msg["GETTER_BORDER_COLOR"] = "%1's Border Color";
    Blockly.Msg["SETTER_BORDER_COLOR"] = "set %1's Border Color to %2";
    Blockly.Msg["GETTER_BORDER_WIDTH"] = "%1's Border Width";
    Blockly.Msg["SETTER_BORDER_WIDTH"] = "set %1's Border Width to %2";
    Blockly.Msg["SETTER_BORDER_WIDTH_BY_STEP"] = "change %1's Border Width by %2";
    Blockly.Msg["SETTER_BORDER_WIDTH_BY_TIME"] = "in %1 seconds set %2's Border Width to %3";

    Blockly.Msg["GETTER_BORDER_RADIUS"] = "%1's Corner Radius";
    Blockly.Msg["SETTER_BORDER_RADIUS"] = "set %1's Corner Radius to %2";
    Blockly.Msg["SETTER_BORDER_RADIUS_BY_STEP"] = "change %1's Corner Radius by %2";
    Blockly.Msg["SETTER_BORDER_RADIUS_BY_TIME"] = "in %1 seconds set %2's Corner Radius to %3";

    Blockly.Msg["GETTER_X_COORDINATE"] = "%1's X Coordinate";
    Blockly.Msg["SETTER_X_COORDINATE"] = "set %1's X Coordinate to %2";
    Blockly.Msg["SETTER_X_COORDINATE_BY_STEP"] = "change %1's X Coordinate by %2";
    Blockly.Msg["SETTER_X_COORDINATE_BY_TIME"] = "in %1 seconds set %2's X Coordinate to %3";
    Blockly.Msg["SETTER_X_COORDINATE_BY_STEP_TIME"] =
      "in %1 seconds change %2's X Coordinate by %3";

    Blockly.Msg["GETTER_Y_COORDINATE"] = "%1's Y Coordinate";
    Blockly.Msg["SETTER_Y_COORDINATE"] = "set %1's Y Coordinate to %2";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_STEP"] = "change %1's Y Coordinate by %2";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_TIME"] = "in %1 seconds set %2's Y Coordinate to %3";
    Blockly.Msg["SETTER_Y_COORDINATE_BY_STEP_TIME"] =
      "in %1 seconds change %2's Y Coordinate by %3";
    Blockly.Msg["SETTER_X_Y_COORDINATE"] = "set %1's X Coordinate to %2, Y Coordinate to %3";
    Blockly.Msg["SETTER_X_Y_BY_TIME"] =
      "in %1 seconds set %2's X Coordinate to %3, Y Coordinate to %4";
    Blockly.Msg["SETTER_X_Y_BY_STEP_TIME"] =
      "in %1 seconds change %2's X Coordinate by %3, Y Coordinate by %4";

    Blockly.Msg["GETTER_ROTATION"] = "%1's Angle";
    Blockly.Msg["SETTER_LEFT_ROTATION"] = "turn %1 left to %2 degrees";
    Blockly.Msg["SETTER_LEFT_ROTATION_BY_STEP"] = "turn %1 left by %2 degrees";
    Blockly.Msg["SETTER_LEFT_ROTATION_BY_TIME"] = "in %1 seconds turn %2 left to %3 degrees";
    Blockly.Msg["SETTER_RIGHT_ROTATION"] = "turn %1 right to %2 degrees";
    Blockly.Msg["SETTER_RIGHT_ROTATION_BY_STEP"] = "turn %1 right by %2 degrees";
    Blockly.Msg["SETTER_RIGHT_ROTATION_BY_TIME"] = "in %1 seconds turn %2 right to %3 degrees";

    Blockly.Msg["GETTER_SCALE"] = "%1's Size";
    Blockly.Msg["SETTER_SCALE"] = "set %1's Size to %2x";
    Blockly.Msg["SETTER_SCALE_BY_STEP"] = "change %1's Size by %2x";
    Blockly.Msg["SETTER_SCALE_BY_TIME"] = "in %1 seconds set %2's Size to %3x";

    Blockly.Msg["GETTER_SHADOW_COLOR"] = "%1's Shadow Color";
    Blockly.Msg["SETTER_SHADOW_COLOR"] = "set %1's Shadow Color to %2";
    Blockly.Msg["GETTER_SHADOW_RADIUS"] = "%1's Shadow Size";
    Blockly.Msg["SETTER_SHADOW_RADIUS"] = "set %1's Shadow Size to %2";
    Blockly.Msg["SETTER_SHADOW_RADIUS_BY_STEP"] = "change %1's Shadow Size by %2";
    Blockly.Msg["SETTER_SHADOW_RADIUS_BY_TIME"] = "in %1 seconds set %2's Shadow Size to %3";

    Blockly.Msg["GETTER_WIDTH"] = "%1's Width";
    Blockly.Msg["SETTER_WIDTH"] = "set %1's Width to %2";
    Blockly.Msg["SETTER_WIDTH_BY_STEP"] = "change %1's Width by %2";
    Blockly.Msg["SETTER_WIDTH_BY_TIME"] = "in %1 seconds set %2's Width to %3";

    Blockly.Msg["GETTER_HEIGHT"] = "%1's Height";
    Blockly.Msg["SETTER_HEIGHT"] = "set %1's Height to %2";
    Blockly.Msg["SETTER_HEIGHT_BY_STEP"] = "change %1's Height by %2";
    Blockly.Msg["SETTER_HEIGHT_BY_TIME"] = "in %1 seconds set %2's Height to %3";
    Blockly.Msg["SETTER_WIDTH_HEIGHT_BY_TIME"] = "in %1 seconds set %2's Width to %3, Height to %4";

    Blockly.Msg["TEXT_FONT_WEIGHT_BOLD"] = "Bold";
    Blockly.Msg["TEXT_FONT_WEIGHT_REGULAR"] = "Regular";
    Blockly.Msg["TEXT_FONT_WEIGHT_LIGHT"] = "Light";

    Blockly.Msg["GETTER_TEXT_FONT_FAMILY"] = "%1's Font";
    Blockly.Msg["SETTER_TEXT_FONT_FAMILY"] = "set %1's Font to %2";
    Blockly.Msg["GETTER_TEXT_FONT_WEIGHT"] = "%1's Text Weight";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT"] = "set %1's Text Weight to %2";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT_BY_STEP"] = "change %1's Text Weight by %2";
    Blockly.Msg["SETTER_TEXT_FONT_WEIGHT_BY_TIME"] = "in %1 seconds set %2's Text Weight to %3";
    Blockly.Msg["GETTER_TEXT_FONT_SIZE"] = "%1's Font Size";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE"] = "set %1's Font Size to %2";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE_BY_STEP"] = "change %1's Font Size by %2";
    Blockly.Msg["SETTER_TEXT_FONT_SIZE_BY_TIME"] = "in %1 seconds set %2's Font Size to %3";
    Blockly.Msg["GETTER_TEXT"] = "%1's Text";
    Blockly.Msg["SETTER_TEXT"] = "set %1's Text to %2";
    Blockly.Msg["GETTER_TEXT_COLOR"] = "%1's Text Color";
    Blockly.Msg["SETTER_TEXT_COLOR"] = "set %1's Text Color to %2";
    Blockly.Msg["GETTER_TEXT_SHADOW_COLOR"] = "%1's Text Shadow Color";
    Blockly.Msg["SETTER_TEXT_SHADOW_COLOR"] = "set %1's Text Shadow Color to %2";
    Blockly.Msg["GETTER_TEXT_SHADOW_RADIUS"] = "%1's Text Shadow Size";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS"] = "set %1's Text Shadow Size to %2";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS_BY_STEP"] = "change %1's Text Shadow Size by %2";
    Blockly.Msg["SETTER_TEXT_SHADOW_RADIUS_BY_TIME"] =
      "in %1 seconds set %2's Text Shadow Size to %3";
    // End English Translations
  }
};
